import { useContext } from 'react';

import { MessagingClient } from '../createMessagingClient';
import { MessagingClientContext } from '../MessagingProvider';

export function useMessagingClient(): MessagingClient {
    const messagingClient = useContext(MessagingClientContext);

    if (!messagingClient) {
        throw new Error(
            "Couldn't find a MessagingClient. Are you sure you configured a MessagingProvider with one?",
        );
    }

    return messagingClient;
}
